import { render, staticRenderFns } from "./suggestTextGold.vue?vue&type=template&id=e8881a6e&scoped=true"
import script from "./suggestTextGold.vue?vue&type=script&lang=js"
export * from "./suggestTextGold.vue?vue&type=script&lang=js"
import style0 from "./suggestTextGold.vue?vue&type=style&index=0&id=e8881a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8881a6e",
  null
  
)

export default component.exports